/**
 * True when a new session token names another workspace than the old one. A sign-in (no old
 * workspace) and a sign-out (no new workspace) are not a workspace change.
 */
export function isWorkspaceChange(previousLicenseId: number | undefined, nextLicenseId: number | undefined): boolean {
  return previousLicenseId !== undefined && nextLicenseId !== undefined && previousLicenseId !== nextLicenseId;
}
